import { render, staticRenderFns } from "./UserCheckbox.vue?vue&type=template&id=2aacf9c2&"
import script from "./UserCheckbox.vue?vue&type=script&lang=js&"
export * from "./UserCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./UserCheckbox.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports